<template>
  <div class="tags-view-container">
    <a-tabs v-model:activeKey="activeKey" type="editable-card" :hide-add="true" @edit="onEdit" @change="handleChange">
      <a-tab-pane v-for="tag in visitedViews" :key="tag.path" :tab="tag.meta.title" :closable="!isAffix(tag)" />
    </a-tabs>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
// import i18n from '@/utils/i18n'

const route = useRoute()
const router = useRouter()
const visitedViews = ref([])
const activeKey = ref('')

// 修改 addVisitedView 方法
const addVisitedView = (view) => {
  if (!visitedViews.value.some(view => view.path === '/index')) {

    visitedViews.value.push({
      path: '/index',
      // name: i18n.global.t('router.home'),
      name: '总览',
      // meta: { title: i18n.global.t('router.home') }
      meta: { title: '总览' }
    })
  }


  if (visitedViews.value.some(v => v.path === view.path)) return
  visitedViews.value.push(
    Object.assign({}, view, {
      title: view.meta?.title || 'unknown',
      query: view.query
    })
  )
  activeKey.value = view.path
}


const isAffix = (tag) => {
  return tag.meta && tag.meta.affix
}

const handleChange = (key) => {
  // 检查目标路由是否存在于已访问视图中
  const targetView = visitedViews.value.find(v => v.path === key)
  if (targetView) {
    activeKey.value = key
    router.push({
      path: key,
      query: targetView.query
    })
  }
}

const onEdit = (targetKey, action) => {
  if (action === 'remove') {
    closeSelectedTag(targetKey)
  }
}

const closeSelectedTag = async (targetKey) => {
  const index = visitedViews.value.findIndex(v => v.path === targetKey)
  if (index === -1) return

  if (targetKey != '/index') {
    visitedViews.value.splice(index, 1)
  }


  if (targetKey === route.path) {
    const latestView = visitedViews.value[visitedViews.value.length - 1]
    if (latestView) {
      await router.push(latestView.path)
    }
  }
}

onMounted(() => {
  addVisitedView(route)
})

watch(
  [() => route.path, () => route.query],
  ([newPath, newQuery]) => {
    // 确保新路径存在于已访问视图中
    const existingView = visitedViews.value.find(v => v.path === newPath)
    if (!existingView) {
      addVisitedView(route)
    } else {
      // 更新现有视图的查询参数
      Object.assign(existingView, {
        query: newQuery
      })
    }
    activeKey.value = newPath
  },
  { immediate: true }
)


</script>

<style lang="less" scoped>
.tags-view-container {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;


  :deep(.ant-tabs-nav) {
    margin: 0;
    padding: 10px 16px 0px;
    background: #fff;

    .ant-tabs-tab {
      border-radius: 2px;
      margin-right: 4px !important;
      padding: 2px 8px;
      font-size: 14px;
      background: #fff;
      border: none;
      border-bottom: 1px solid #f0f0f0;

      &.ant-tabs-tab-active {
        background: #f4f5f9;
        border-bottom: 1px solid #f0f0f0;

        .ant-tabs-tab-btn {
          color: #3970fe;

        }

        .ant-tabs-tab-remove {
          color: #3970fe;
        }
      }
    }
  }
}

.tags-view-container:deep(.ant-tabs-tab-remove) {
  margin-left: 3px;
}

.clon:deep(.ant-tabs-tab-remove) {
  display: none;

}

@media screen and (min-width: 1921px) {
  :deep(.ant-tabs-nav) {

    // .ant-tabs-tab-btn
    .ant-tabs-tab-btn {
      font-size: 16px !important;
      padding: 2px;

    }

    .ant-tabs-tab-remove {
      font-size: 16px !important;
      padding: 7px 0 0 0 !important;
    }
  }

}
</style>